"use client";
import React from "react";
import { Box, Container, Grid, Typography, Card, CardContent } from "@mui/material";
import { EmojiObjectsRounded, PublicRounded, Diversity3Rounded, WorkspacePremiumRounded } from "@mui/icons-material";
import Header from "./header";
import Footer from "./footer";
import { headerLikeBg, heroSx, titleGradient } from "./components/ui/themeBits";

export const metadata = {
  title: "Our Vision | AISECT Inter College",
  description:
    "Our vision is to build a future-ready institution that empowers students to lead with knowledge, character, and compassion.",
  openGraph: { title: "Our Vision | AISECT Inter College" },
};

export default function VisionPage() {
  return (
    <>
      <Header />

      {/* HERO */}
      <Box sx={heroSx}>
        <Container maxWidth="lg">
          <Typography component="h1" align="center" sx={titleGradient}>
            Our Vision
          </Typography>
          <Typography align="center" sx={{ mt: 1, color: "text.secondary", fontSize: { xs: 15, sm: 16 } }}>
            Where we want to be in the next 5–10 years.
          </Typography>
        </Container>
      </Box>

      {/* MAIN */}
      <Container maxWidth="lg" sx={{ my: { xs: 3.5, sm: 5 } }}>
        <Grid container spacing={{ xs: 2.5, sm: 3 }}>
          {/* Vision statement */}
          <Grid item xs={12}>
            <Card elevation={0} sx={{ p: { xs: 2.25, sm: 2.75 }, borderRadius: 3, ...headerLikeBg }}>
              <Typography sx={{ fontWeight: 800, fontSize: "clamp(20px, 2.6vw, 28px)", mb: 1 }}>
                A future-ready institution
              </Typography>
              <Typography sx={{ color: "text.secondary", fontSize: "clamp(16.5px, 1.9vw, 19px)", lineHeight: 1.9 }}>
                We envision a vibrant campus that sets benchmarks in academic outcomes, innovation culture,
                and social impact. We aim to integrate technology, pedagogy, and community partnerships to
                create pathways for higher education and employability, especially for first-generation learners.
              </Typography>
            </Card>
          </Grid>

          {/* Vision goals */}
          {[
            {
              icon: <EmojiObjectsRounded />,
              title: "Innovation Culture",
              text: "Labs, clubs, fairs, and projects that encourage experimentation and design thinking.",
            },
            {
              icon: <WorkspacePremiumRounded />,
              title: "Benchmark Outcomes",
              text: "Consistently improving board results and competitive exam readiness.",
            },
            {
              icon: <Diversity3Rounded />,
              title: "Inclusive Campus",
              text: "Safe, supportive, and accessible environment for all students and staff.",
            },
            {
              icon: <PublicRounded />,
              title: "Community Impact",
              text: "Local engagement, environmental stewardship, and service-learning initiatives.",
            },
          ].map((g, i) => (
            <Grid item xs={12} md={6} key={i}>
              <Card elevation={0} sx={{ p: { xs: 2, sm: 2.5 }, borderRadius: 3, height: "100%", ...headerLikeBg }}>
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.25 }}>
                  <Box sx={{ mt: "2px" }}>{g.icon}</Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: 800,
                        fontSize: "clamp(14px, 1.8vw, 16px)", // larger title
                      }}
                    >
                      {g.title}
                    </Typography>
                    <Typography
                      sx={{
                        color: "text.secondary",
                        fontSize: "clamp(12px, 1.4vw, 14px)", // larger body text
                        lineHeight: 1.7,
                      }}
                    >
                      {g.text}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>

      <Footer />
    </>
  );
}
